const stickyNav = document.querySelector(".navigation-sticky");

if (stickyNav) {
   const toggleButton = stickyNav.querySelector(".navigation-sticky-toggle");
   const stickyNavMenu = stickyNav.querySelector(".navigation-sticky-nav");

   // Null-Guard: Script nur ausführen wenn beide Elemente vorhanden sind
   if (!toggleButton || !stickyNavMenu) {
      console.warn("navigation-sticky.js: .navigation-sticky-toggle oder .navigation-sticky-nav fehlt.");
   } else {

      const openStickyNav = () => {
         toggleButton.setAttribute("aria-expanded", "true");
         stickyNavMenu.classList.add("show");
      };

      const closeStickyNav = () => {
         toggleButton.setAttribute("aria-expanded", "false");
         stickyNavMenu.classList.remove("show");
      };

      // Toggle bei Klick auf den Button
      toggleButton.addEventListener("click", () => {
         const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
         if (isExpanded) {
            closeStickyNav();
         } else {
            openStickyNav();
         }
      });

      // Anchor-Links in der Nav schließen das Menü automatisch
      const anchorLinks = stickyNavMenu.querySelectorAll("a[href]");
      anchorLinks.forEach((link) => {
         link.addEventListener("click", () => {
            closeStickyNav();
         });
      });

      // Escape-Taste schließt die Nav
      document.addEventListener("keydown", (event) => {
         if (event.code === "Escape" && toggleButton.getAttribute("aria-expanded") === "true") {
            closeStickyNav();
            toggleButton.focus();
         }
      });
   }
}